import { type ReactNode, createContext, useContext, useState } from "react";

interface LayoutContextType {
	showNavbar: boolean;
	setShowNavbar: (show: boolean) => void;
	showMediaPlayer: boolean;
	setShowMediaPlayer: (show: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | null>(null);

/**
 * Use this hook to access the layout context and enable conditional rendering of the navbar
 * @returns
 */
export function useLayout() {
	const context = useContext(LayoutContext);
	if (!context) {
		throw new Error("useLayout must be used within a LayoutProvider");
	}
	return context;
}

interface LayoutProviderProps {
	children: ReactNode;
}

/**
 * Use this component to wrap your app in a layout provider
 * @param children
 * @returns
 */
export function LayoutProvider({ children }: LayoutProviderProps) {
	const [showNavbar, setShowNavbar] = useState(true);
	const [showMediaPlayer, setShowMediaPlayer] = useState(true);

	return (
		<LayoutContext.Provider
			value={{
				showNavbar,
				setShowNavbar,
				showMediaPlayer,
				setShowMediaPlayer,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
}
